import { ReactComponent as EmtpyJobListIllustration } from "assets/images/job-list-empty-illustration.svg";
import { formatDate } from "components/hosted-scraping/ProjectFormatDate";

export const EmptyJobList = ({firstJobScheduled}: {firstJobScheduled?: Date}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2 my-40 text-center text-gray dark:text-neutral-600">
      <EmtpyJobListIllustration />
      <div className="text-gray dark:text-neutral-600 font-droid text-base font-semibold">No jobs yet</div>
      <div>
        {firstJobScheduled && <div>Your project is scheduled to start at <span className="font-semibold">{formatDate(firstJobScheduled)}</span></div>}
        {!firstJobScheduled && <div>Start your first job by clicking on the "RUN JOB NOW" button on top or use the frequency feature to run a job at a later point in your preferred intervals. </div>}
      </div>
    </div>
  );
}
